module.exports = __webpack_public_path__ + "static/img/rightc9.32fd374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/rightc9.png
// module id = +APc
// module chunks = 37